import last from "lodash/last";
import {
  FIELD_ASSIGNEE_ID_KEY,
  FIELD_ATTACHMENT_IDS_KEY,
  FIELD_AVAILABILITY_KEY,
  FIELD_BOOKING_CATEGORY_ID_KEY,
  FIELD_COMMUNICATION_TYPE_KEY,
  FIELD_DESCRIPTION_KEY,
  FIELD_INTEREST_QUESTIONS_KEY,
  FIELD_MIN_REQUIRED_COUNT_KEY,
  FIELD_NAME_KEY,
  FIELD_POST_UNTIL_KEY,
  FIELD_PRIVACY_KEY,
  FIELD_SKILLS_FRAMEWORK_IDS_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useColumnsNames = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections" });

  return useMemo(
    () => ({
      [FIELD_NAME_KEY]: t("basicInformation.name"),
      [FIELD_DESCRIPTION_KEY]: t("basicInformation.description"),
      [FIELD_POST_UNTIL_KEY]: t("basicInformation.expiryDate.title"),
      [FIELD_MIN_REQUIRED_COUNT_KEY]: t("basicInformation.numberOfVacancies"),
      [FIELD_BOOKING_CATEGORY_ID_KEY]: t("basicInformation.bookingCategory.title"),
      [FIELD_ASSIGNEE_ID_KEY]: t("basicInformation.assignee"),
      [last(FIELD_AVAILABILITY_KEY.split(".")) as string]: t("availability.percentageTitle"),
      [FIELD_PRIVACY_KEY]: t("privacy.title"),
      [FIELD_INTEREST_QUESTIONS_KEY]: t("showInterestQuestions.title"),
      [FIELD_COMMUNICATION_TYPE_KEY]: t("conversation.title"),
      [FIELD_SKILLS_FRAMEWORK_IDS_KEY]: t("skillsFrameworks.title"),
      [FIELD_ATTACHMENT_IDS_KEY]: t("attachments.title")
    }),
    [t]
  );
};
